import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchActionRequestDetails,
  storeCurrentReviewableAction,
} from "../actions/index.js";
import { getActionRequestDetails } from "../services/index.js";

export function* actionRequestDetails(action) {
  const response = yield call(getActionRequestDetails, action.payload);
  const data = yield response.data;
  yield put(storeCurrentReviewableAction({ ...data, id: action.payload }));
}
export function* actionRequestDetailsSaga() {
  yield takeLatest(fetchActionRequestDetails.toString(), actionRequestDetails);
}
